import React from 'react';
import styled from 'styled-components';
import {mobileMediaQuery} from '../../styles';
import {ReactComponent as CNLogo} from '../../assets/cn-logo.svg';
import {getCurrentLang} from '../../utils/i18n';

const FooterCNButton = () => {
    let lang = getCurrentLang();
    let url =
        lang === 'pt'
            ? 'https://cnapp.cartoonnetwork.com.br'
            : 'https://cnapp.cartoonnetworkla.com';

    return (
        <Container href={url} target="_blank">
            <BlobTop />
            <Logo />
        </Container>
    );
};

const Container = styled.a`
    position: relative;

    background: url(${require('../../assets/blob_button.png')}), black;
    background-size: contain;
    background-position: bottom;
    background-repeat: no-repeat;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    display: flex;
    height: 46px;
    overflow: hidden;
    width: 220px;
    margin-bottom: 22px;
    ${mobileMediaQuery} {
        min-width: 290px;
        width: 100%;
    }
`;

const Logo = styled(CNLogo)`
    width: 48px;
    height: 28px;
`;

const BlobTop = styled.img.attrs({
    src: require('../../assets/blob_bottom_md.png'),
})`
    position: absolute;
    top: 0px;
    transform: rotate(180deg);
    width: 100%;
    margin-right: 0px !important;
`;

export default FooterCNButton;
